export const API_BASE_URL = 'https://mikenoel.pythonanywhere.com/api/v1/'
